// File Management
export const errorPage = 'Error'

// HOME PAGE
export const homeTitle = '「ミンティア」MYラベルメーカー｜ウキウキアサヒ島'
export const cityText = 'ウキウキアサヒ島にもどる'
export const stepTitle = 'MYラベルの作り方'
export const FAQlink = 'よくあるお問い合わせ'

// TnC Page
export const TnC = '利用規約'
export const continueText = 'つづける'
export const backText = 'もどる'

// Layout Page
export const layoutTitle = 'ラベルの形を選ぼう'

// Template Page
export const templateTitle = 'テンプレートを選ぼう'

// Preview Page
export const previewTitle = 'プレビュー'
export const buttonGroupTitle = '自由に編集しよう'
export const deleteModalTitle =
  'これまでの編集内容を全て消して、初めからやり直しますか？'
export const deleteModalMessage = '※「はい」を押すと元に戻せません'
export const resetModalTitle =
  '完成したラベル画像は、長押しして<br/>ご自身の端末に保存してください。'
export const resetModalMessage =
  '作成しなおすとデータは削除されます。よろしいですか？'
export const linkAsahi = '「ミンティア」MYラベルメーカーに関するお問い合わせ'

// Change Background Page
export const backgroundTitle = '背景を変更しよう'

// Add Text Page
export const textTitle = 'テキストを編集しよう'
export const addText = 'テキストを追加'
export const colorSelectText = 'カラーを選択してください'

export const japaneseCharactersNotAllowed =
  'このフォントでは日本語の文字は使用できません。'
export const maximumInput15JapaneseCharacters =
  '全角15文字・半角30文字以下で入力してください'
export const maximumInput30EnglishCharacters =
  'アルファベットで入力すると、最大30文字です。'
export const maxLengthInputText30Charactor =
  '日本語で入力すると、最大３０文字です。'
export const youJustTypedInNGWord =
  '利用できない表現が含まれています。入力し直してください。'
export const noteAddText =
  'テキスト入力いただいた個人情報について、当社ではサーバーでの保管を含めて当該個人情報を取得いたしません。<br />そのため、ラベルの作成完了（画像データ保存）後の当該個人情報の取扱いについては、画像データの保管や画像データを利用した印刷を含め、お客様自身で適切な管理をお願いいたします。'

// Add Stamp Page
export const stampTitle = 'スタンプを編集しよう'
export const addStamp = 'スタンプを追加'
export const chooseStampTitle = '追加するスタンプを選ぼう'
export const chooseStampTlt = 'スタンプを選ぼう'
export const chooesStampBackBtn = '追加せずもどる'
export const chooseStampDecideBtn = '決定'

// Create Avatar
export const createAvatarTitle = 'アバターを編集しよう'
export const makeSticker = 'ラベルをつくる'
export const stickerShape = 'まずはラベルの形を選ぼう'
export const colorSubtitle = 'カラー選択'
export const editAvatar = 'アバター編集'
export const addAvatar = 'アバターを追加'
export const showAvatar = 'アバターを表示する'

// Common Text
export const nextText = 'つぎへ'
export const cancelText = 'キャンセル'
export const confirmText = 'はい'
export const completeText = '作業完了'
export const completeText2 = '完了'
export const decideAndBackToPreviewText = '決定してプレビューに戻る'

// Export page
export const exportTitle = 'MYラベル完成！'
export const exportTitle1 = '画像を長押しで保存できます'
export const socialTitle = 'オリジナルラベルをシェアしよう！'
export const printTitle = '印刷データを保存する'
export const storeTitle = 'コンビニシールプリント用'
export const homePrintTitle = 'ご家庭プリンター用'
// Portrait mode modal
export const portraitModeTitle = 'スマートフォンの向きを縦にしてください'
export const portraitModeDesc = 'ラベル制作は縦モードでご利用いただけます'
// Background page
export const doYouWantDeleteTextData = 'テキストデータを削除しますか？'
export const theTextYouAddedSupportBackgroundLogo =
  '追加したテキストは、ロゴ付きの背景をサポートしていないフォントです。'
// FQA page
export const fqaTitle = 'よくあるお問い合わせ'
export const fqaNotice =
  'ご利用にあたって<br/>※本サービスをご利用される方は、著作権法その他の関連法令を遵守したうえで、第三者の著作権や肖像権等の権利を侵害しないよう十分ご注意ください。<br/>※本サービスを利用して制作されたものは、作成された方の個人的な責任の範囲においてお楽しみください。<br/>'
